import React from "react";
import RegisterForm from "components/AuthComponent/RegisterForm";
import LoginForm from "components/AuthComponent/login";
import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import ForgotPasswordForm from "components/AuthComponent/ForgotPasswordForm/ForgotPasswordForm";
import ProtectedRoutes from "routes/ProtectedRoutes";
import TaskDetails from "pages/TaskDetails/TaskDetails";
import PublicRoutes from "routes/PublicRoutes";
import TaskDashboard from "components/EmployerPages/TaskDashboard.jsx";
import TaskReport from "components/EmployerPages/TaskReport.jsx";

const App = () => {
  initializeIcons();

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<PublicRoutes />}>
            <Route index element={<RegisterForm />} />

            <Route path="forgot-password" element={<ForgotPasswordForm />} />
            <Route path="login" element={<LoginForm />} />
          </Route>

          <Route path="/task-dashboard" element={<ProtectedRoutes />}>
            <Route index element={<TaskDashboard />} />
          </Route>

          <Route path="/task-report" element={<ProtectedRoutes />}>
            <Route index element={<TaskReport />} />
          </Route>

          <Route path="/user" element={<ProtectedRoutes />}>
            <Route path="task-details" element={<TaskDetails />} />
          </Route>
        </Routes>
      </QueryClientProvider>
    </>
  );
};

export default App;
